/* gac-page.js — behaviour for the Garden Advent landing template */
(function () {
  if (window.__gacInit) return; window.__gacInit = true;
  var d = document, RM = false;
  try { RM = window.matchMedia('(prefers-reduced-motion: reduce)').matches; } catch (e) {}
  function $(q, c) { return (c || d).querySelector(q); }
  function $$(q, c) { return Array.prototype.slice.call((c || d).querySelectorAll(q)); }
  function esc(s) { return String(s).replace(/[&<>"]/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[c]; }); }

  var buy = $('[data-gac-buy]');
  var CUR = (window.Shopify && Shopify.currency && Shopify.currency.active) || (buy && buy.getAttribute('data-cur')) || 'EUR';
  var NF = null;
  function mkNF() { try { NF = new Intl.NumberFormat(d.documentElement.lang || 'en', { style: 'currency', currency: CUR }); } catch (e) { NF = null; } }
  mkNF();
  function fmt(c) { return NF ? NF.format(c / 100) : (c / 100).toFixed(2) + ' ' + CUR; }

  /* ---------- reveal on scroll ---------- */
  var st = $('.gac-story h2');
  if (st && !st.getAttribute('data-split')) {
    st.setAttribute('data-split', '1');
    st.innerHTML = st.textContent.trim().split(/\s+/).map(function (w, i) { return '<span class="w" style="transition-delay:' + i * 45 + 'ms">' + esc(w) + '</span>'; }).join(' ');
  }
  var rv = $$('.rv, .gac-story h2');
  if (!('IntersectionObserver' in window) || RM) rv.forEach(function (el) { el.classList.add('in'); });
  else {
    var io = new IntersectionObserver(function (es) { es.forEach(function (e) { if (e.isIntersecting) { e.target.classList.add('in'); io.unobserve(e.target); } }); }, { rootMargin: '0px 0px -8% 0px', threshold: .12 });
    rv.forEach(function (el) { io.observe(el); });
    setTimeout(function () { rv.forEach(function (el) { if (el.getBoundingClientRect().top < window.innerHeight) el.classList.add('in'); }); }, 2500);
  }

  /* ---------- gallery ---------- */
  var mainImg = $('[data-main]');
  $$('.gac-th').forEach(function (t) {
    t.addEventListener('click', function () {
      $$('.gac-th').forEach(function (x) { x.classList.remove('on'); });
      t.classList.add('on');
      var src = t.getAttribute('data-src'); if (!mainImg || !src) return;
      mainImg.style.opacity = '0';
      setTimeout(function () { mainImg.src = src; mainImg.removeAttribute('srcset'); mainImg.style.opacity = '1'; }, 180);
    });
  });

  /* ---------- countdown bar ---------- */
  $$('[data-gac-bar]').forEach(function (bar) {
    var cut = Date.parse(bar.getAttribute('data-cut')), cd = $('[data-gac-cd]', bar), r = $('[data-gac-r]', bar);
    function p2(n) { return (n < 10 ? '0' : '') + n; }
    function tick() {
      var ms = cut - Date.now();
      if (!(ms > 0)) { r.textContent = bar.getAttribute('data-after') || ''; if (!r.textContent) r.style.display = 'none'; return false; }
      var s = Math.floor(ms / 1000), dd = Math.floor(s / 86400); s %= 86400; var h = Math.floor(s / 3600); s %= 3600; var m = Math.floor(s / 60); s %= 60;
      cd.innerHTML = (dd > 0 ? '<b>' + dd + '</b><small>D</small>' : '') + '<b>' + p2(h) + '</b><small>H</small><b>' + p2(m) + '</b><small>M</small><b>' + p2(s) + '</b><small>S</small>';
      return true;
    }
    if (isNaN(cut)) { if (r) r.style.display = 'none'; } else if (tick()) setInterval(tick, 1000);
  });

  /* ---------- delivery ETA ---------- */
  $$('[data-eta]').forEach(function (el) {
    var mn = +el.getAttribute('data-min') || 5, mx = +el.getAttribute('data-max') || 8;
    function add(n) { var t = new Date(); var k = 0; while (k < n) { t.setDate(t.getDate() + 1); var w = t.getDay(); if (w && w < 6) k++; } return t; }
    try { var f = new Intl.DateTimeFormat(d.documentElement.lang || 'en', { month: 'short', day: 'numeric' }); el.textContent = f.format(add(mn)) + ' – ' + f.format(add(mx)); } catch (e) {}
  });

  /* ---------- bundle picker ---------- */
  var q = 1, vid, price, cmp, d2, d3, spId, spP, slId, slP;
  if (buy) {
    vid = buy.getAttribute('data-vid'); price = +buy.getAttribute('data-price'); cmp = +buy.getAttribute('data-compare') || price;
    d2 = +buy.getAttribute('data-d2') || 0; d3 = +buy.getAttribute('data-d3') || 0;
    spId = buy.getAttribute('data-sp'); spP = +buy.getAttribute('data-spp') || 0;
    slId = buy.getAttribute('data-sl'); slP = +buy.getAttribute('data-slp') || 0;
  }
  function bundle(n) { var dsc = n === 2 ? d2 : n === 3 ? d3 : 0; return { now: price * n - dsc, was: n === 1 ? cmp : cmp * n }; }
  var spc = $('[data-up="sp"]'), slc = $('[data-up="sl"]');
  function totals() {
    var b = bundle(q), n = b.now, w = b.was;
    if (spc && spc.checked && spId) { n += spP; w += spP; }
    if (slc && slc.checked && slId) { n += slP; w += slP; }
    return { n: n, w: w };
  }
  function renderTotal() {
    if (!buy) return;
    var t = totals(), tn = $('[data-tn]'), tw = $('[data-tw]');
    if (tn) tn.textContent = fmt(t.n);
    if (tw) tw.textContent = t.w > t.n ? fmt(t.w) : '';
    $$('[data-sp-price]').forEach(function (e) { e.textContent = fmt(t.n); });
  }
  var cards = $$('.gac-card');
  cards.forEach(function (c) {
    var n = +c.getAttribute('data-q'), b = bundle(n);
    var nEl = $('[data-n]', c), oEl = $('[data-o]', c), per = $('[data-per]', c);
    if (nEl) nEl.textContent = fmt(b.now);
    if (oEl) { if (b.was > b.now) oEl.textContent = fmt(b.was); else oEl.style.display = 'none'; }
    if (per && n > 1) per.innerHTML = fmt(Math.round(b.now / n)) + ' each &middot; <b>Save ' + fmt(b.was - b.now) + '</b>';
    function pick() { cards.forEach(function (x) { x.classList.remove('on'); x.setAttribute('aria-checked', 'false'); }); c.classList.add('on'); c.setAttribute('aria-checked', 'true'); q = n; renderTotal(); }
    c.addEventListener('click', pick);
    c.addEventListener('keydown', function (e) { if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); pick(); } });
  });
  [spc, slc].forEach(function (x) { if (x) x.addEventListener('change', renderTotal); });
  renderTotal();

  /* ---------- cart drawer ---------- */
  function req(method, url, body) {
    return fetch(url, { method: method, headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' }, body: body ? JSON.stringify(body) : undefined, credentials: 'same-origin' })
      .then(function (r) { return r.json().then(function (j) { return { ok: r.ok, j: j }; }); });
  }
  var dr = $('.gac-dr'), list = $('[data-list]'), foot = $('[data-foot]'), okEl = $('[data-ok]');
  function setCount(c) { $$('[data-count]').forEach(function (b) { b.textContent = c; if (c > 0) b.removeAttribute('hidden'); else b.setAttribute('hidden', ''); }); }
  function render(c) {
    if (!dr) return;
    if (c.currency && c.currency !== CUR) { CUR = c.currency; mkNF(); }
    setCount(c.item_count || 0);
    if (!c.items.length) { list.innerHTML = '<div class="gac-dr__e">Your cart is empty.</div>'; foot.style.display = 'none'; return; }
    foot.style.display = '';
    list.innerHTML = c.items.map(function (it, i) {
      var img = it.image ? '<img src="' + esc(it.image) + (it.image.indexOf('?') > -1 ? '&' : '?') + 'width=180" alt="">' : '<span style="font-size:26px">🌿</span>';
      var da = 0; (it.line_level_discount_allocations || []).forEach(function (a) { da += a.amount; });
      return '<div class="gac-li" style="animation-delay:' + i * 60 + 'ms"><div class="gac-li__i">' + img + '</div><div class="gac-li__m"><div class="gac-li__t">' + esc(it.product_title) + '</div>' +
        (it.variant_title && it.variant_title !== 'Default Title' ? '<div class="gac-li__v">' + esc(it.variant_title) + '</div>' : '') +
        (da ? '<div class="gac-li__d">Bundle savings −' + fmt(da) + '</div>' : '') +
        '<div class="gac-li__r"><div class="gac-q"><button type="button" data-k="' + esc(it.key) + '" data-q="' + (it.quantity - 1) + '" aria-label="Decrease">−</button><span>' + it.quantity + '</span><button type="button" data-k="' + esc(it.key) + '" data-q="' + (it.quantity + 1) + '" aria-label="Increase">+</button></div>' +
        '<div class="gac-li__p">' + fmt(it.final_line_price) + (it.original_line_price > it.final_line_price ? '<s>' + fmt(it.original_line_price) + '</s>' : '') + '</div></div></div></div>';
    }).join('');
    $('[data-sub]').textContent = fmt(c.original_total_price);
    var sv = $('[data-save]');
    if (c.total_discount > 0) { sv.parentNode.style.display = ''; sv.textContent = '−' + fmt(c.total_discount); } else sv.parentNode.style.display = 'none';
    $('[data-total]').textContent = fmt(c.total_price);
  }
  if (list) list.addEventListener('click', function (e) {
    var b = e.target.closest('[data-k]'); if (!b) return;
    list.style.opacity = '.5';
    req('POST', '/cart/change.js', { id: b.getAttribute('data-k'), quantity: Math.max(0, +b.getAttribute('data-q')) }).then(function (r) { list.style.opacity = ''; if (r.j && r.j.items) render(r.j); });
  });
  function openDr(ok) { if (!dr) { location.href = '/cart'; return; } okEl.style.display = ok ? '' : 'none'; dr.classList.add('on'); d.documentElement.style.overflow = 'hidden'; }
  function closeDr() { if (dr) dr.classList.remove('on'); d.documentElement.style.overflow = ''; }
  function loadCart(ok, show) { return req('GET', '/cart.js').then(function (r) { if (r.j) render(r.j); if (show) openDr(ok); }); }
  $$('[data-close]').forEach(function (b) { b.addEventListener('click', closeDr); });
  d.addEventListener('keydown', function (e) { if (e.key === 'Escape') closeDr(); });
  $$('[data-open-cart]').forEach(function (b) { b.addEventListener('click', function () { loadCart(false, true); }); });
  loadCart(false, false);

  var msg = $('[data-msg]');
  function busy(on) { $$('[data-atc]').forEach(function (b) { b.disabled = on; b.style.opacity = on ? '.7' : ''; }); }
  function addToCart() {
    if (!vid) return;
    busy(true); if (msg) msg.textContent = '';
    req('GET', '/cart.js').then(function (cr) {
      var have = {}; ((cr.j && cr.j.items) || []).forEach(function (it) { have[it.variant_id] = 1; });
      var items = [{ id: +vid, quantity: q }];
      if (spc && spc.checked && spId && !have[spId]) items.push({ id: +spId, quantity: 1 });
      if (slc && slc.checked && slId && !have[slId]) items.push({ id: +slId, quantity: 1 });
      return req('POST', '/cart/add.js', { items: items });
    }).then(function (r) {
      busy(false);
      if (!r.ok) { if (msg) msg.textContent = (r.j && (r.j.description || r.j.message)) || 'Could not add to cart. Please try again.'; return; }
      var gift = buy && buy.getAttribute('data-gift');
      var p = gift ? req('POST', '/cart/update.js', { attributes: { 'Free gift': gift } }) : Promise.resolve();
      p.then(function () { var cb = $('.gac-cartbtn'); if (cb) { cb.classList.remove('bump'); void cb.offsetWidth; cb.classList.add('bump'); } loadCart(true, true); });
    }).catch(function () { busy(false); location.href = '/cart'; });
  }
  $$('[data-atc]').forEach(function (b) { b.addEventListener('click', addToCart); });

  /* ---------- scroll-to buttons ---------- */
  $$('[data-go]').forEach(function (a) {
    a.addEventListener('click', function (e) {
      var t = $(a.getAttribute('href')); if (!t) return; e.preventDefault();
      var y = t.getBoundingClientRect().top + window.pageYOffset - 90;
      try { window.scrollTo({ top: y, behavior: 'smooth' }); } catch (er) { window.scrollTo(0, y); }
    });
  });

  /* ---------- sticky bar ---------- */
  var sticky = $('.gac-sticky'), mainAtc = $('.gac-box [data-atc]'), ft = $('.gac-ft');
  if (sticky && mainAtc && 'IntersectionObserver' in window) {
    var vis = { atc: true, ft: false };
    function upd() { sticky.classList.toggle('on', !vis.atc && !vis.ft && mainAtc.getBoundingClientRect().top < 0); }
    new IntersectionObserver(function (es) { vis.atc = es[0].isIntersecting; upd(); }).observe(mainAtc);
    if (ft) new IntersectionObserver(function (es) { vis.ft = es[0].isIntersecting; upd(); }).observe(ft);
  }

  /* ---------- autoplay videos in view ---------- */
  var vids = $$('video[data-gac-v]');
  if (vids.length) {
    if ('IntersectionObserver' in window) {
      var vio = new IntersectionObserver(function (es) { es.forEach(function (en) { var v = en.target; if (en.isIntersecting) { v.preload = 'auto'; var pr = v.play(); if (pr && pr.catch) pr.catch(function () {}); } else v.pause(); }); }, { threshold: .25, rootMargin: '300px 0px' });
      vids.forEach(function (v) { vio.observe(v); });
    } else vids.forEach(function (v) { v.autoplay = true; });
  }

  /* ---------- falling leaves / snow on hero ---------- */
  var cv = $('.gac-fx');
  if (cv && !RM && cv.getContext) {
    var ctx = cv.getContext('2d'), W, H, P = [], col = cv.getAttribute('data-c') || '#2E7D4F';
    function size() { var r = cv.getBoundingClientRect(); W = cv.width = r.width; H = cv.height = r.height; }
    size(); window.addEventListener('resize', size);
    for (var i = 0; i < 26; i++) P.push({ x: Math.random() * W, y: Math.random() * H, s: 4 + Math.random() * 7, v: .3 + Math.random() * .7, a: Math.random() * 6.28, r: .01 + Math.random() * .02, leaf: Math.random() < .55 });
    var running = true;
    new IntersectionObserver(function (es) { running = es[0].isIntersecting; if (running) frame(); }).observe(cv);
    function frame() {
      if (!running) return;
      ctx.clearRect(0, 0, W, H);
      P.forEach(function (p) {
        p.y += p.v; p.a += p.r; p.x += Math.sin(p.a) * .5;
        if (p.y > H + 10) { p.y = -10; p.x = Math.random() * W; }
        ctx.save(); ctx.translate(p.x, p.y); ctx.rotate(p.a); ctx.globalAlpha = .28;
        if (p.leaf) { ctx.fillStyle = col; ctx.beginPath(); ctx.ellipse(0, 0, p.s, p.s / 2.2, 0, 0, 6.28); ctx.fill(); }
        else { ctx.fillStyle = '#C9A227'; ctx.beginPath(); ctx.arc(0, 0, p.s / 3, 0, 6.28); ctx.fill(); }
        ctx.restore();
      });
      requestAnimationFrame(frame);
    }
    frame();
  }
})();
